// /Users/stuartmcgeer/portalworx/frontend/src/components/cards/StandardCard.tsx

import React, { ReactNode } from 'react';
import styled from 'styled-components';

// Styling for a standard card container with padding, background, and borders
const Card = styled.div`
    padding: 1.25rem;
    background-color: white;
    border-radius: 0.5rem;
    border: 1px solid #e0e0e0;
    position: relative;
    display: flex;
    flex-direction: column;
`;

// Props definition for the StandardCard component
interface StandardCardProps {
    children: ReactNode; // The content to display inside the card
    className?: string;  // Optional custom CSS class
}

// Functional component representing a standard card for flexible content display
const StandardCard: React.FC<StandardCardProps> = ({ children, className = '' }) => {
    return <Card className={className}>{children}</Card>;
};

export default StandardCard;
